"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var Text_1 = require("../../atoms/Text");
var styles_1 = __importDefault(require("./styles"));
exports.Tile = react_1.default.memo(function (_a) {
    var idPrefix = _a.idPrefix, name = _a.name, removable = _a.removable, children = _a.children, _b = _a.onRemove, onRemove = _b === void 0 ? function () { } : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, _d = _a.nameVisible, nameVisible = _d === void 0 ? true : _d, _e = _a.height, height = _e === void 0 ? '100%' : _e, _f = _a.width, width = _f === void 0 ? '100%' : _f, _g = _a.compact, compact = _g === void 0 ? false : _g, rest = __rest(_a, ["idPrefix", "name", "removable", "children", "onRemove", "onClick", "nameVisible", "height", "width", "compact"]);
    var classes = (0, styles_1.default)({ compact: compact });
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ height: height, width: width }, rest, { className: classes.root }, { children: [removable && ((0, jsx_runtime_1.jsx)(core_1.IconButton, __assign({ id: "".concat(idPrefix, "RemoveButton"), color: "inherit", "aria-label": "remove ".concat(name), className: classes.remove, "data-testid": "remove-tile", onClick: onRemove }, { children: (0, jsx_runtime_1.jsx)(icons_1.Close, {}) }))), (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ className: classes.content }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, __assign({ id: "".concat(idPrefix, "Button"), onClick: onClick, "aria-label": name, className: classes.button }, { children: children })) })), nameVisible && ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ className: classes.name }, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ size: "medium", whiteSpace: "nowrap", component: "p", overflow: "hidden", textOverflow: "ellipsis" }, { children: name })) })))] })));
});
